import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { isEmpty } from './validators';

export const APP_STORE_LINK = 'https://apps.apple.com/us/app/ripple-street/id1623388148';
export const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.ripplestreetfun';

export const getDateString = (value, format, isUnix, convertToLocal) => {
  if (
    (typeof value === 'string'
      || typeof value === 'number'
      || typeof value === 'object')
    && !Array.isArray(value)
    && !isEmpty(format)
  ) {
    if (isUnix) {
      return moment.unix(Number(value)).format(format);
    }
    if (convertToLocal) {
      return moment
        .parseZone(value)
        .local()
        .format(format);
    }
    return moment.parseZone(value).format(format);
  }
  return '';
};
// eslint-disable-next-line no-unused-vars
const requestBlob = async (uri, fileSize) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.onload = () => {
      resolve(xhr.response);
    };
    xhr.onerror = () => {
      // const message = fileSize
      //   ? `The file size is too large. Please try again with a smaller file, preferably under ${Math.round(
      //     fileSize,
      //   )}MB.`
      //   : 'The file size is too large. Please try again with a smaller file.';
      // Toast.danger({
      //   message,
      // });
      reject(new TypeError('Blob network request failed'));
    };
    xhr.responseType = 'blob';

    xhr.open('GET', uri, true);
    xhr.send(null);
  });
};
export async function getBlob(fileUri) {
  try {
    return await requestBlob(fileUri);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
}

export const uploadUGCMiddleWare = async (url, payLoad) => {
  try {
    const data = await fetch(url, { method: 'PUT', body: payLoad });
    return data.status;
  } catch (error) {
    const typedError = error;
    return typedError;
  }
};

export const convertToLocalDate = date => {
  const inputTime = momentTimezone.tz(date, 'America/New_York');
  return inputTime.local();
};

export const validateFileMime = (file, allowedTypes = ['image/png', 'image/jpg', 'image/jpeg']) => {
  return allowedTypes.indexOf(file.type) !== -1;
};

export const openAppStore = () => {
  window.open(
    APP_STORE_LINK,
    '_blank',
  );
};

export const openPlayStore = () => {
  window.open(
    PLAY_STORE_LINK,
    '_blank',
  );
};
